import { http } from "./config";

class LogService {
  listar(params) {
    return http.get(`/v1/logs-atividades`, {
        params
    });
  }
}

export default new LogService();
